import { API_JWT_BASE_URL } from '../http'

export const TEST_CONNECTION_API = `${API_JWT_BASE_URL}/Ldap/testconnection`
export const TEST_BASEDN_API = `${API_JWT_BASE_URL}/Ldap/testbasedn`

export const LDAP_QUERY_KEYS = {
  TEST_CONNECTION: 'TEST_CONNECTION',
  TEST_BASEDN: 'TEST_BASEDN'
}
